import { EmbeddedPost, FacebookProvider } from "react-facebook";
import { FB_APP_ID } from "@features/seo/utils/constants";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

export type FacebookEmbedCustomProps = {
  url: string;
  /** Optional additional styling for the embed container */
  className?: string;
};

export default function FacebookEmbedCustom({
  url,
  className,
}: FacebookEmbedCustomProps): React.ReactElement {
  const { isScreenSM } = useWindowSize();

  if (!url) return <></>;

  return (
    <FacebookProvider appId={FB_APP_ID}>
      <div
        className={cn(
          "mb-6 flex justify-center [&>div]:w-full [&>div]:max-w-[550px]",
          className
        )}
        data-testid="facebook-embed-custom-component"
      >
        <EmbeddedPost
          href={url}
          width={isScreenSM ? "500px" : "auto"}
          lazy
          showText
        />
      </div>
    </FacebookProvider>
  );
}
